const grey = {
  100: '#F3F3F6',
  200: '#E5E5EB',
  300: '#D8D8E1',
  400: '#CBCBD6',
  500: '#B2B2C1',
  // text.disabled
  600: '#828297',
  700: '#626277' // text.secondary
};

export default grey;